import React from "react";
import { View, Text } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { FontFamilies } from "@/constants/Typography";

const StatItem = ({ amount, description }: { amount: string; description: string }) => (
  <View style={styles.statItem}>
    <Text style={styles.statAmount}>{amount}</Text>
    <Text style={styles.statDescription}>{description}</Text>
  </View>
);

const OnboardSlide1 = () => {
  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <View style={styles.textContainer}>
          <Text style={styles.title}>
            {"Billions go unclaimed\nevery year"}
          </Text>
          <Text style={styles.subtitle}>
            Sparrow finds money you didn't know you were owed — and helps you claim it.
          </Text>
        </View>

        <View style={styles.statsContainer}>
          <StatItem amount="$1B+" description="in class action settlements" />
          <StatItem amount="$5B+" description="in unclaimed government money" />
          <StatItem amount="$20B+" description="in missed refunds from brands & services" />
        </View>
      </View>
    </View>
  );
};

export default OnboardSlide1;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 16,
    justifyContent: "center",
  },
  content: {
    gap: 40,
    alignItems: "center",
  },
  textContainer: {
    gap: 12,
    alignItems: "center",
  },
  title: {
    fontFamily: FontFamilies.Inter.SemiBold,
    fontSize: 32,
    lineHeight: 38,
    color: "#161D14",
    textAlign: "center",
    width: "100%",
  },
  subtitle: {
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 15,
    lineHeight: 24,
    color: "#161D14",
    textAlign: "center",
    opacity: 0.7,
    letterSpacing: -0.3,
    paddingHorizontal: 0,
  },
  statsContainer: {
    gap: 24,
    width: "100%",
  },
  statItem: {
    gap: 2,
    alignItems: "center",
  },
  statAmount: {
    fontFamily: FontFamilies.Inter.Bold,
    fontSize: 24,
    lineHeight: 28,
    color: "#0F9129",
    textAlign: "center",
    letterSpacing: -0.48,
  },
  statDescription: {
    fontFamily: FontFamilies.Inter.Regular,
    fontSize: 16,
    lineHeight: 24,
    color: "#161D14",
    textAlign: "center",
    opacity: 0.7,
    letterSpacing: -0.32,
  },
});
